<template>
  <el-container>
    <!-- 标题 -->
    <el-header class="pa-0">
      <div class="bg-color-w ht-62 dy-flex jy-c-sb">
        <div :xs="4" class="pl-30 dy-flex jy-c-sb align-i-c">
          <img src="/img/images/dbsx_icon.png" class="wt-40 ht-40" />
          <div class="pl-10 fs-20">{{ $t("common.syssetting") }}</div>
        </div>
        <!-- 中英文切换 -->
        <Languageqh v-if="$store.state.sysCs.sfqy_zywqh == '1'"></Languageqh>
      </div>
    </el-header>
    <!-- 内容 -->
    <el-main>
      <!-- 菜单 -->
      <el-row class="pb-20 menuList">
        <div
          :class="
            activeindex == 0
              ? 'color-primary br-color-primary bw-b-3 br-b-solid '
              : ''
          "
          class="mx-10 py-10 cursor-p float-l"
          @click="activeindex = 0"
        >
          {{ $t("common.cssz") }}
        </div>
        <div
          :class="
            activeindex == 3
              ? 'color-primary br-color-primary bw-b-3 br-b-solid '
              : ''
          "
          class="mx-10 py-10 cursor-p float-l"
          @click="activeindex = 3"
        >
          {{ $t("common.dlrz") }}
        </div>
        <div
          :class="
            activeindex == 4
              ? 'color-primary br-color-primary bw-b-3 br-b-solid '
              : ''
          "
          class="mx-10 py-10 cursor-p float-l"
          @click="activeindex = 4"
        >
          {{ $t("common.czrz") }}
        </div>
        <div
          :class="
            activeindex == 5
              ? 'color-primary br-color-primary bw-b-3 br-b-solid '
              : ''
          "
          class="mx-10 py-10 cursor-p float-l"
          @click="activeindex = 5"
        >
          {{ $t("common.ympz") }}
        </div>
        <div
          :class="
            activeindex == 6
              ? 'color-primary br-color-primary bw-b-3 br-b-solid '
              : ''
          "
          class="mx-10 py-10 cursor-p float-l"
          @click="activeindex = 6"
        >
          {{ $t("common.gggl") }}
        </div>
        <div
          :class="
            activeindex == 7
              ? 'color-primary br-color-primary bw-b-3 br-b-solid '
              : ''
          "
          class="mx-10 py-10 cursor-p float-l"
          @click="activeindex = 7"
        >
          {{ $t("common.xtgx") }}
        </div>
        <div
          :class="
            activeindex == 8
              ? 'color-primary br-color-primary bw-b-3 br-b-solid '
              : ''
          "
          class="mx-10 py-10 cursor-p float-l"
          @click="activeindex = 8"
          v-if="isaduser"
        >
          {{ $t("common.qhzh") }}
        </div>
      </el-row>
      <!-- 参数设置 -->
      <syscs v-if="activeindex == 0"></syscs>
      <!-- 登录日志 -->
      <dlrz v-else-if="activeindex == 3"></dlrz>
      <!-- 操作日志 -->
      <czrz v-else-if="activeindex == 4"></czrz>
      <!-- 页面设置 -->
      <ympz v-else-if="activeindex == 5"></ympz>
      <!-- 公告管理 -->
      <gggl v-else-if="activeindex == 6"></gggl>
      <!-- 系统更新 -->
      <xtgx v-else-if="activeindex == 7"></xtgx>
      <!-- 切换账号 -->
      <qhzh v-else-if="activeindex == 8"></qhzh>
    </el-main>
  </el-container>
</template>

<script>
import syscs from "@/views/cssz/syscs.vue";
import ympz from "@/views/xtgl/ympz.vue";
import czrz from "@/views/xtgl/czrz.vue";
import dlrz from "@/views/xtgl/dlrz.vue";
import gggl from "@/views/xtgl/gggl.vue";
import jsgl from "@/views/xtgl/jsgl.vue";
import yhgl from "@/views/xtgl/yhgl.vue";
import xtgx from "@/views/xtgl/xtgx.vue";
import qhzh from "@/views/xtgl/qhzh.vue";
import Languageqh from "@/components/Languageqh.vue";
import * as adlogin from "@/api/adLogin";

export default {
  name: "xtcs",
  components: {
    syscs,
    ympz,
    czrz,
    dlrz,
    gggl,
    jsgl,
    yhgl,
    xtgx,
    qhzh,
    Languageqh,
  },
  computed: {},
  data() {
    return {
      tableData: [],
      dialogFormVisible: false,
      activeindex: 0,
      dialogTitle: "", // 模态框标题
      ruleForm: {
        csid: "",
        csname: "",
        csvalue: "",
        iscolor: "0",
        colorVal: "",
      },
      isaduser: false,
      dialogTitleIcon: "", // 模态框标题图标
      saveFlg: "", // 保存操作区分
      disabledFlg: false, // 输入框是否可编辑
    };
  },
  methods: {},
  mounted() {
    adlogin.isaduser().then((res) => {
      this.isaduser = res.data.data;
    });
  },
};
</script>
<style lang="scss" scoped>
.formClass {
  margin-bottom: 16px;
}
::v-deep .el-input-group__prepend {
  border: none;
  padding: 0;
}
</style>
